import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureToggleModule } from 'ngx-feature-toggle';
import { NavigationModule } from './modules/navigation/navigation.module';
import { SelfServiceRoutingModule } from './self-service-routing.module';
import { SelfServiceComponent } from './self-service.component';
import { CompanyService } from './services/company.service';
import { UserManagementService } from './services/user-management.service';
import { UserRegistrationService } from './services/user-registration.service';
import { UsersService } from './services/users.service';
import { EndCustomerService } from '../register-end-customer/services/end-customer.service';
import { PurchasesService } from './services/purchases.service';
import { SelfServiceResolver } from './self-service.resolver';
import { FooterComponent } from '../shared/footer/footer.component';

const material = [MatToolbarModule, MatSidenavModule, MatCardModule, MatButtonModule, MatIconModule, MatMenuModule];

const modules = [
    CommonModule,
    RouterModule,
    SelfServiceRoutingModule,
    FeatureToggleModule,
    TranslateModule.forChild(),
    NavigationModule,
    ...material,
];

@NgModule({
    declarations: [SelfServiceComponent],
    imports: [...modules, MatSidenavModule, FooterComponent],
    providers: [
        SelfServiceResolver,
        UserRegistrationService,
        EndCustomerService,
        UserManagementService,
        UsersService,
        CompanyService,
        PurchasesService,
    ],
})
export class SelfServiceModule {}
